/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_FinanceInputs */

const vi_nav_finance = /** @type {(inputs: Nav_FinanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài chính`)
};

/**

* @param {Nav_FinanceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_finance = /** @type {((inputs?: Nav_FinanceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_FinanceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_finance(inputs)
});